import { defineStore } from 'pinia';



export const useKittenStore = defineStore("kitten", {
    state: () => ({
        kitten: {
            aidan: {
                parent_sire: { "name": "Bibo", "link": "http://www.novascotias-mainecoons.de/crew/kater/bibo/", "external": true },
                parent_dam: { "name": "Nova Scotia's Sirona", "link": "/crew/siri", "external": false },
                birthday: "28. Mai 2023",
                ems: "MCO as",
                photos: [
                    {
                        path: "aidan_18wochen_6.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_18wochen_5.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_18wochen_4.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_18wochen_3.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_18wochen_2.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_18wochen_1.jpg",
                        text: "Aidan mit 18 Wochen",
                    },
                    {
                        path: "aidan_78tage_2.jpeg",
                        text: "Aidan mit 78 Tagen",
                    },
                    {
                        path: "aidan_78tage_1.jpeg",
                        text: "Aidan mit 78 Tagen im Profil - Sonne!",
                    },
                    {
                        path: "aidan_46tage_1.jpeg",
                        text: "Aidan mit 46 Tagen",
                    },
                    {
                        path: "aidan_42tage_3.jpeg",
                        text: "Aidan mit 42 Tagen",
                    },
                    {
                        path: "aidan_42tage_2.jpeg",
                        text: "Aidan mit 42 Tagen",
                    },
                    {
                        path: "aidan_42tage_1.jpeg",
                        text: "Aidan mit 42 Tagen",
                    },
                    {
                        path: "aidan_30tage_1.jpeg",
                        text: "Aidan mit 30 Tagen",
                    },
                    {
                        path: "aidan_30tage_2.jpeg",
                        text: "Aidan mit 30 Tagen",
                    },
                    {
                        path: "aidan_21tage_1.jpg",
                        text: "Aidan mit 21 Tagen",
                    },
                    {
                        path: "aidan_21tage_2.jpg",
                        text: "Aidan mit 21 Tagen",
                    },
                    {
                        path: "aidan_21tage_3.jpg",
                        text: "Aidan mit 21 Tagen",
                    },
                    {
                        path: "aidan_10tage_2.jpeg",
                        text: "Aidan mit 10 Tagen",
                    },
                    {
                        path: "aidan_10tage_1.jpeg",
                        text: "Aidan mit 10 Tagen",
                    },
                    {
                        path: "aidan_07tage_1.jpeg",
                        text: "Aidan mit 7 Tagen",
                    },
                ],
                color: "Blue Solid Smoke",
                wurf: "A",
                colorDetails: [
                    "Non-Agouti (keine Zeichnung)",
                    "Verdünnung",
                    "Smoke (Heterozygot)",
                    "Kein White/Spotwhite",
                    "Classic (\"überzeichnet\" durch Non-Agouti)",
                    "Black",
                ],
                description: "Aidan, ein gaelischer Name mit der Bedeutung 'Kleines Feuer' ist der Hitzkopf des Wurfs. Erstgeborener, erster dabei die Augen zu öffnen und der Erste, der seinen Unmut hörbar kund tut. Ob zu viel Nähe der Geschwister oder zu wenig, Aidan meldet sich und hält die Bande auf Trab.",
            },
            akira: {
                parent_sire: { "name": "Bibo", "link": "http://www.novascotias-mainecoons.de/crew/kater/bibo/", "external": true },
                parent_dam: { "name": "Nova Scotia's Sirona", "link": "/crew/siri", "external": false },
                birthday: "28. Mai 2023",
                ems: "MCO fs 22",
                photos: [
                    {
                        path: "akira_18wochen_4.jpg",
                        text: "Akira mit 18 Wochen",
                    },
                    {
                        path: "akira_18wochen_3.jpg",
                        text: "Akira mit 18 Wochen",
                    },
                    {
                        path: "akira_18wochen_2.jpg",
                        text: "Akira mit 18 Wochen",
                    },
                    {
                        path: "akira_18wochen_1.jpg",
                        text: "Akira mit 18 Wochen",
                    },
                    {
                        path: "akira_78tage_3.jpeg",
                        text: "Akira mit 78 Tagen",
                    },
                    {
                        path: "akira_78tage_1.jpeg",
                        text: "Akira mit 78 Tagen",
                    },
                    {
                        path: "akira_42tage_4.jpeg",
                        text: "Akira mit 42 Tagen",
                    },
                    {
                        path: "akira_42tage_3.jpeg",
                        text: "Akira mit 42 Tagen",
                    },
                    {
                        path: "akira_42tage_2.jpeg",
                        text: "Akira mit 42 Tagen",
                    },
                    {
                        path: "akira_42tage_1.jpeg",
                        text: "Akira mit 42 Tagen",
                    },
                    {
                        path: "akira_30tage_1.jpeg",
                        text: "Akira mit 30 Tagen",
                    },
                    {
                        path: "akira_30tage_2.jpeg",
                        text: "Akira mit 30 Tagen",
                    },
                    {
                        path: "akira_30tage_3.jpeg",
                        text: "Akira mit 30 Tagen",
                    },
                    {
                        path: "akira_21tage_1.jpg",
                        text: "Akira mit 21 Tagen",
                    },
                    {
                        path: "akira_21tage_2.jpg",
                        text: "Akira mit 21 Tagen",
                    },
                    {
                        path: "akira_10tage_2.jpeg",
                        text: "Akira mit 10 Tagen",
                    },
                    {
                        path: "akira_10tage_1.jpeg",
                        text: "Akira mit 10 Tagen",
                    },
                    {
                        path: "akira_07tage_2.jpeg",
                        text: "Akira mit 7 Tagen",
                    },
                    {
                        path: "akira_07tage_1.jpeg",
                        text: "Akira mit 7 Tagen",
                    },
                ],
                color: "Black Silver Torbie Classic",
                wurf: "A",
                colorDetails: [
                    "Agouti / Zeichnung (kann Non-Agouti tragen)",
                    "Vollfarbe (trägt Verdünnung)",
                    "Silver (Heterozygot)",
                    "Kein White/Spotwhite",
                    "Classic",
                    "Black + Red",
                ],
                description: "Akira ist ein schottischer Name, der 'Anker' bedeutet. Akira ist lebhaft und spiegelt im Umgang oft die eigene Ruhe, oder eben Unruhe von einem selbst wieder. Das vor Augen geführt zu bekommen hilft uns dabei uns zu 'erden' und die innere Unruhe loszulassen. Wir hatten lange überlegt, ob wir Akira abgeben können, die Kleine hat uns mit ihrer Zeichnung und ihrem Charakter umgehauen. Sie \"ruft\" Jaqueline, sobald sie sie sieht, und hat sie komplett ausgesucht, Akira bleibt bei uns.",
            },
            arely: {
                parent_sire: { "name": "Bibo", "link": "http://www.novascotias-mainecoons.de/crew/kater/bibo/", "external": true },
                parent_dam: { "name": "Nova Scotia's Sirona", "link": "/crew/siri", "external": false },
                birthday: "28. Mai 2023",
                ems: "MCO gs",
                photos: [
                    {
                        path: "arely_18wochen_4.jpg",
                        text: "Arely mit 18 Wochen",
                    },
                    {
                        path: "arely_18wochen_3.jpg",
                        text: "Arely mit 18 Wochen",
                    },
                    {
                        path: "arely_18wochen_2.jpg",
                        text: "Arely mit 18 Wochen",
                    },
                    {
                        path: "arely_18wochen_1.jpg",
                        text: "Arely mit 18 Wochen",
                    },
                    {
                        path: "arely_78tage_2.jpeg",
                        text: "Arely mit 78 Tagen",
                    },
                    {
                        path: "arely_78tage_1.jpeg",
                        text: "Arely mit 78 Tagen",
                    },
                    {
                        path: "arely_42tage_4.jpeg",
                        text: "Arely mit 42 Tagen",
                    },
                    {
                        path: "arely_42tage_3.jpeg",
                        text: "Arely mit 42 Tagen",
                    },
                    {
                        path: "arely_42tage_2.jpeg",
                        text: "Arely mit 42 Tagen",
                    },
                    {
                        path: "arely_42tage_1.jpeg",
                        text: "Arely mit 42 Tagen",
                    },
                    {
                        path: "arely_30tage_1.jpeg",
                        text: "Arely mit 30 Tagen",
                    },
                    {
                        path: "arely_30tage_3.jpeg",
                        text: "Arely mit 30 Tagen - Mit Mama Siri",
                    },
                    {
                        path: "arely_30tage_2.jpeg",
                        text: "Arely mit 30 Tagen",
                    },
                    {
                        path: "arely_30tage_4.jpeg",
                        text: "Arely mit 30 Tagen",
                    },
                    {
                        path: "arely_21tage_3.jpg",
                        text: "Arely mit 21 Tagen",
                    },
                    {
                        path: "arely_21tage_2.jpg",
                        text: "Arely mit 21 Tagen",
                    },
                    {
                        path: "arely_21tage_1.jpg",
                        text: "Arely mit 21 Tagen",
                    },
                    {
                        path: "arely_10tage_2.jpeg",
                        text: "Arely mit 10 Tagen",
                    },
                    {
                        path: "arely_10tage_1.jpeg",
                        text: "Arely mit 10 Tagen",
                    },
                    {
                        path: "arely_07tage_2.jpeg",
                        text: "Arely mit 7 Tagen",
                    },
                    {
                        path: "arely_07tage_1.jpeg",
                        text: "Arely mit 7 Tagen",
                    },
                ],
                color: "Blue Tortie Smoke",
                wurf: "A",
                colorDetails: [
                    "Non-Agouti (keine Zeichnung)",
                    "Verdünnung",
                    "Smoke (Heterozygot)",
                    "Kein White/Spotwhite",
                    "Classic (\"überzeichnet\" durch Non-Agouti)",
                    "Black + Red",
                ],
                description: "Arely, ausgesprochen \"Arelei\", ist das erfüllte Versprechen unserer Zuchtkatze. 'Arely' ist ein Name mit keltischem Ursprung und bedeutet unter Anderem 'Versprechen'. Sie hat alles, was sich Niklas von einer Zuchtkatze gewünscht hat. Charakterlich ist sie eine unglaublich entspannte Persönlichkeit, die sich aber durchsetzen kann. Sie sucht unsere Nähe und weiß ganz genau, dass sie Niklas um die Tatze gewickelt hat und das merkt man an ihrem Anhimmeln! 😊",
            },
        },
    }),
    getters: {
    },
    actions: {
    }
});
